import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-height: 85vh; 
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 400;
  color: #111827;
  margin: 0;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #111827;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 48px;
  border: 2px solid #dcdfe4;
  border-radius: 6px;
  font-size: 15px;
  color: #111827;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #1a4d4d;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: none;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #d1d5db;
  }
`;

export const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
`;

export const CategoryCard = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: ${({ $active }) => ($active ? '#e6f2f2' : '#ffffff')};
  border: 2px solid ${({ $active }) => ($active ? '#1a4d4d' : '#dcdfe4')};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${({ $active }) => ($active ? '#c0dede' : '#f9fafb')};
    border-color: ${({ $active }) => ($active ? '#0f3333' : '#d1d5db')};
  }
`;

export const CategoryEmoji = styled.div`
  font-size: 28px;
  line-height: 1;
`;

export const CategoryInfo = styled.div`
  flex: 1;
  text-align: left;
`;

export const CategoryName = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #111827;
  margin-bottom: 2px;
`;

export const CategoryCount = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const ResultsInfo = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 16px;

  strong {
    color: #111827;
    font-weight: 300;
  }
`;

export const IconsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
`;

export const IconCard = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 8px;
  background: ${({ selected }) => (selected ? '#e6f2f2' : '#ffffff')};
  border: 2px solid ${({ selected }) => (selected ? '#1a4d4d' : '#dcdfe4')};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 90px;

  &:hover {
    background: ${({ selected }) => (selected ? '#c0dede' : '#f9fafb')};
    border-color: ${({ selected }) => (selected ? '#0f3333' : '#1a4d4d')};
    transform: translateY(-2px);
  }
`;

export const IconEmoji = styled.div`
  font-size: 32px;
  line-height: 1;
`;

export const IconName = styled.div`
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
  text-align: center;
  word-break: break-word;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const EmptyEmoji = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

export const EmptyText = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0;
`;
